"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValueContainer = exports.Value = exports.DayNumber = exports.Day = exports.CalendarCell = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const colors_1 = require("../../../../../assets/styles/colors");
const media_1 = require("../../../../../utils/media");
const CalendarCell = styled_components_1.default.div `
  flex: 1 0 auto;
  padding: 4px;
  aspect-ratio: 1;
  position: relative;
  height: calc(100% - 9px);
  width: calc(100% / 7 - 9px);
  max-width: calc(100% / 7 - 9px);
  min-width: 0;
`;
exports.CalendarCell = CalendarCell;
const Day = (0, styled_components_1.default)(CalendarCell) `
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  text-align: center;
  margin: 0 0 0.6rem 0;
  background-color: ${(props) => props.$color};
  width: 100%;
  cursor: ${(props) => (props.$hasValue ? "pointer" : "default")};
  transition: all 0.2s ease-in-out;
  border: 2px solid transparent;

  ${(props) => props.$isSelected &&
    `
    border: 1px solid ${props.$borderColor || colors_1.gray400};
    box-shadow: 0 0 0 1px ${props.$borderColor || colors_1.gray400};
  `}
  ${(props) => props.$hasValue &&
    `
    &:hover {
      transform: scale(1.05);
      border: 2px solid ${props.$borderColor};
    }
  `}

  @media (${media_1.media.smallDesktop}) {
    border-radius: 5px;
  }
`;
exports.Day = Day;
const DayNumber = styled_components_1.default.span `
  font-size: 12px;
  text-align: end;
  display: ${(props) => (props.$isVisible ? "block" : "none")};
  color: ${(props) => (props.$isGrayedOut ? colors_1.gray100 : colors_1.gray400)};
  opacity: 50%;

  @media (${media_1.media.smallDesktop}) {
    font-size: 18px;
  }
  @media (${media_1.media.desktop}) {
    font-size: 10px;
  }
`;
exports.DayNumber = DayNumber;
const ValueContainer = styled_components_1.default.div `
  font-size: 3.8vw;
  font-weight: 600;
  text-align: start;
  display: ${(props) => (props.$isVisible ? "block" : "none")};
  color: ${colors_1.gray400};
  padding-top: 11%;
  position: relative;
  height: 100%;
  display: flex;
  align-items: flex-end;
  overflow: hidden;

  @media (${media_1.media.smallDesktop}) {
    font-size: 3.2vw;
  }
  @media (${media_1.media.desktop}) {
    font-size: 0.9vw;
  }
`;
exports.ValueContainer = ValueContainer;
const Value = styled_components_1.default.div `
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
exports.Value = Value;
